/** FNV-1a 32-bit over the UTF-8 bytes of a string. The only string-to-seed function (FS-02 §3.1). */
export function hashSeed(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i) & 0xff;
    // 32-bit FNV prime multiply via imul.
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}
